import { Divider } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import {
	ConfirmScheduleButton,
	CreateTemplateButton,
	PreviousStepButton,
	SaveButtonsGroup,
} from '../../containers/save-buttons/SaveButtonsGroup';
import ContentConstants from '../../contentConstants';
import { IConfirmScheduleActionCreators, ISurveyBuilderActionCreators } from '../../models/IActionCreators';
import { IConfirmScheduleState } from '../../store/ConfirmScheduleStore';
import { ISurveyBuilderState } from '../../store/SurveyBuilderStore';
import { CardLayout } from '../common';
import { FinalConfirmation, SummaryItemLayout, SurveyPreview, SurveyPreviewCallout } from './confirm-schedule';

export type IConfirmScheduleProps = {
	surveyId: number;
	publishing: boolean;
	isSurveyTemplate: boolean;
	MakeTemplatePublic: (surveyId: number) => void;
} & IConfirmScheduleState &
	ISurveyBuilderState &
	IConfirmScheduleActionCreators &
	ISurveyBuilderActionCreators;

export interface IConfirmScheduleInternal {
	showFinalConfirmation: boolean;
}

export class ConfirmSchedule extends React.Component<IConfirmScheduleProps, IConfirmScheduleInternal> {
	constructor(props: IConfirmScheduleProps) {
		super(props);

		this.state = { showFinalConfirmation: false };

		this.toggleFinalConfirmation = this.toggleFinalConfirmation.bind(this);
	}

	public render() {
		const { isSurveyTemplate, errorItems, summaryItems, summaryItemsLoading, surveyId, MakeTemplatePublic } = this.props;
		const { showFinalConfirmation } = this.state;

		return (
			<CardLayout loading={summaryItemsLoading} title={ContentConstants.CONFIRMSCHEDULE_PAGE_TITLE} header={<SurveyPreview />}>
				{!summaryItemsLoading && (!errorItems || errorItems.length === 0) && <SurveyPreviewCallout />}
				{!summaryItemsLoading && errorItems && errorItems.length > 0 && (
					<SummaryItemLayout
						id='ErrorSection'
						surveyId={surveyId}
						headerText={ContentConstants.CONFIRMSCHEDULE_ERROR_HEADER}
						summaryItems={errorItems}
					/>
				)}
				{!summaryItemsLoading && summaryItems && (
					<SummaryItemLayout
						id='SummarySection'
						surveyId={surveyId}
						headerText={ContentConstants.CONFIRMSCHEDULE_SUMMARY_HEADER}
						summaryItems={summaryItems}
					/>
				)}
				<Divider type='dashed' />
				<SaveButtonsGroup>
					<PreviousStepButton />
					{isSurveyTemplate ? (
						<CreateTemplateButton errorItems={errorItems} makeTemplatePublic={() => MakeTemplatePublic(surveyId)} />
					) : (
						<ConfirmScheduleButton errorItems={errorItems} toggleFinalConfirmation={this.toggleFinalConfirmation} />
					)}
				</SaveButtonsGroup>
				<FinalConfirmation
					show={showFinalConfirmation}
					publishing={this.props.publishing}
					cancel={this.toggleFinalConfirmation}
					submit={() => this.props.Schedule(surveyId)}
				/>
			</CardLayout>
		);
	}

	public toggleFinalConfirmation() {
		this.setState({ showFinalConfirmation: !this.state.showFinalConfirmation });
	}
}
